import React from 'react'
import TranslationForm from './translation-form'
import createReactClass from 'create-react-class'
var translations = {};
translations['nl-NL'] = require('../../language/lang.nl.js');
translations['nl-BE'] = require('../../language/lang.nl.js');
translations['nb-NO'] = require('../../language/lang.no.js');
translations['en-GB'] = require('../../language/lang.en.js');
translations['de-DE'] = require('../../language/lang.de.js');
translations['fr-FR'] = require('../../language/lang.fr.js');
translations['sv-SE'] = require('../../language/lang.se.js');

var TranslateHelper = createReactClass({

  	getInitialState: function () {
  		return {baseFile: null};
  	},

  	getTranslations: function () {
  		if (this.state.baseFile === null) {
  			return null;
  		}
  		return translations[this.state.baseFile];

  	},
	selectChangeHandler: function (event) {
		this.setState({baseFile: event.target.value});
	},

	render: function() {

		return (
		  <div style={{padding: '15px'}}>
		    <h1>Translate helper</h1>

		    Select language to edit:
		    <select name="baseFile" onChange={this.selectChangeHandler} value={this.state.baseFile}>
		    	<option value="">-- Select --</option>
		    	<option value="nl-NL">Dutch</option>
		    	<option value="nb-NO">Norwegian</option>
		    	<option value="en-GB">English</option>
		    	<option value="de-DE">German</option>
		    	<option value="fr-FR">French</option>
		    	<option value="se-SE">Swedish</option>
		    </select>
		    <br/><br/>
		    <TranslationForm data={this.getTranslations()} />
		  </div>
		);
	}
});

export default TranslateHelper;
